import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './SelectedItemForBreadcrumbs.module.scss';

interface ISelectedItemForBreadcrumbs {
	label: string;
	onDelete: () => void;
}

const SelectedItemForBreadcrumbs: React.FC<ISelectedItemForBreadcrumbs> = ({ label, onDelete }) => (
	<div className={style.container} data-test="SelectedItemForBreadcrumbs">
		<Text
			className={style.valueItem}
			translationNameSpace="listing"
			translationKey={label}
			theme="secondary"
			size="xs"
			withTooltip={true}
		/>
		<div className={style.deleteBtn} onClick={onDelete}>
			<svg className={style.deleteIcon}>
				<use xlinkHref={`${breadcrumbs}#closeSelectItem`} />
			</svg>
		</div>
	</div>
);

export default SelectedItemForBreadcrumbs;
